// extracted by mini-css-extract-plugin
export default {"root":"_6CIt__6CIt","title":"WYiBj_WYiBj"};